<template>
    <div class="home">
        <el-container>
            <el-aside width="50px" style="display: flex; align-items: center; flex-direction: column;background-color:#000000;">
                
                <el-popover
                    placement="right"
                    width="120"
                    trigger="hover">
                    <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
                        <div><span style="font-size: 18px;font-weight: 600;">Flutter Helper</span></div>
                        <img src="/img/icons/WeChat.png" style="height: 100px;height:100px;margin-top:10px;"/>
                        <div style="margin-top:10px;font-size:10px;"><span>@Samle</span></div>
                    </div>
                    <img class="menu-logo" slot="reference" src="/img/icons/logo.png"/>
                </el-popover>
                
                <i class="el-icon-d-arrow-left menu-icon" title="隐藏左侧" @click="leftCol = 0" v-if="leftCol != 0"></i>
                <i class="el-icon-d-arrow-right menu-icon" title="隐藏右侧" @click="leftCol = 24" v-if="leftCol == 0"></i>
                <i class="el-icon-s-fold menu-icon" :title="`向左移动 ${(leftCol/24).toFixed(2)*100}%`" @click="leftMove" v-if="leftCol != 0"></i>
                <i class="el-icon-s-unfold menu-icon" :title="`向右移动 ${((24-leftCol)/24).toFixed(2)*100}%`" @click="rightMove" v-if="leftCol != 24"></i>
                <i class="el-icon-download menu-icon" title="导出数据" @click="download"></i>
                <el-upload
                    action=''
                    accept=".json"
                    :show-file-list="false"
                    :auto-upload="false"
                    :multiple="false"
                    :on-change="changeFile"
                    >
                    <i class="el-icon-upload2 menu-icon" title="导入数据"></i>
                </el-upload>
                <img id="codeIcon" class="menu-icon" src="/img/icons/code1.png" title="代码生成" @click="makeCode" @mouseover="imgHover" @mouseout="imgUnHover"/>

                <i class="el-icon-refresh menu-icon" title="重置数据" @click="cleanData"></i>
                <i class="el-icon-unlock menu-icon" title="解锁内容" @click="lockData = !lockData" v-if="lockData"></i>
                <i class="el-icon-lock menu-icon" title="锁定内容" @click="lockData = !lockData" v-if="!lockData"></i>
            </el-aside>
            <el-main>
                <el-row>
                    <el-col :span="leftCol" style="border-right:1px solid #afafaf;position:relative;height:100vh;">
                        <el-table :data="tableDatas[tableName]" style="width: 100%;overflow-y: auto;" height="calc( 100vh - 60px )">
                            <el-table-column align="center" type="index" width="50" fixed="left" :label="`${tableDatas[tableName].length}`"></el-table-column>
                            <el-table-column align="center" prop="name" :label="`${titleCase(tableName)} - 字段`" maxWidth="360" fixed="left">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.name" placeholder="请输入字段" size="small"
                                        @change="updateData"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="epithet" label="字段名" maxWidth="240">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.epithet" placeholder="请输入字段名" size="small"
                                        @change="updateData"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="typ" align="center" label="字段类型">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.typ" placeholder="请输入字段类型" size="small" style="width:100%;"
                                        @change="updateData">
                                        <el-option v-for="item in typeOption" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="search" label="参数搜索">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.searchTyp" placeholder="请选择搜索类型" size="small" style="width:100%;"
                                        @change="updateData">
                                        <el-option v-for="item in searchOption" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="search" label="统一搜索" width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.search"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="only" label="单独搜索" width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.only"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="new" label="本次新增" width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.new"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="" align="center" class-name="small-padding fixed-width" width="60px;"
                                fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini" plain
                                        @click="delData(scope.row, scope.$index)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-row :gutter="20" style="width:100%;position: absolute;bottom:10px;padding: 0 10px;margin: 0;">
                            <el-col :span="6">
                                <el-input v-model="dbName" placeholder="请输入数据库名称" size="small">
                                    <template slot="append">.db</template>
                                </el-input>
                            </el-col>
                            <el-col :span="6">
                                <el-select v-model="tableName" @change="tableNameChange" filterable allow-create size="small"
                                    default-first-option placeholder="选择或新建表单名">
                                    <el-option v-for="item in tableNames" :key="item" :label="item" :value="item"
                                        style="position:relative;">
                                        <span style="float: left">{{ item }}</span>
                                        <i style="float: right; color: rgb(255, 102, 102);position: absolute;top:30%;right:10px;"
                                            class="el-icon-delete" @click="delItem(item)"></i>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="6">
                                <el-button plain style="width:100%;" type="primary" @click="addData()" size="small">新增字段</el-button>
                            </el-col>
                            <el-col :span="6">
                                <el-button plain style="width:100%;" :type="lockData ? 'danger' : 'primary'"
                                    @click="lockData = !lockData" size="small">{{ lockData ? '解锁内容' : '锁定内容' }}</el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="24 - leftCol">
                        <codeEditor v-if="showEditor" languageChange :language="language"
                            @language-change="languageChange" :value="code" @input="(val) => code = val"></codeEditor>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
        <el-drawer size="90%" title="" :visible.sync="drawer" direction="btt" :with-header="false">
            <div class="drawer-header">{{`${titleCase(tableName)} - 代码生成`}}<span style="margin-left:20px;font-size:15px;font-weight:500;color:#3f3f3f;">{{showActiveName(activeName)}}</span></div>
            <el-tabs v-model="activeName" @tab-click="handleClick" class="tab-box">
                <el-tab-pane :label="`${tableName}_view.dart`" name="views">
                    <codeEditorMini v-if="showViewsEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="viewsCode" @input="(val) => viewsCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`${tableName}_controller.dart`" name="controllers">
                    <codeEditorMini v-if="showControllersEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="controllersCode" @input="(val) => controllersCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`${tableName}_binding.dart`" name="bindings">
                    <codeEditorMini v-if="showBindingsEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="bindingsCode" @input="(val) => bindingsCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`edit_${tableName}_view.dart`" name="editViews">
                    <codeEditorMini v-if="showEditViewsEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="editViewsCode" @input="(val) => editViewsCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`edit_${tableName}_controller.dart`" name="editControllers">
                    <codeEditorMini v-if="showEditControllersEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="editControllersCode" @input="(val) => editControllersCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`edit_${tableName}_binding.dart`" name="editBindings">
                    <codeEditorMini v-if="showEditBindingsEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="editBindingsCode" @input="(val) => editBindingsCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`${tableName}_element.dart`" name="element">
                    <codeEditorMini v-if="showElementEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="elementCode" @input="(val) => elementCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane :label="`${tableName}_list_view.dart`" name="listView">
                    <codeEditorMini v-if="showListViewEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="listViewCode" @input="(val) => listViewCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane label="app_pages.dart" name="pages">
                    <codeEditorMini v-if="showPagesEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="pagesCode" @input="(val) => pagesCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane label="app_routes.dart" name="routes">
                    <codeEditorMini v-if="showRoutesEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="routesCode" @input="(val) => routesCode = val"></codeEditorMini>
                </el-tab-pane>
                <el-tab-pane label="page_store.dart" name="store">
                    <codeEditorMini v-if="showStoreEditor" languageChange :language="language" @language-change="languageChange" style="height:100%;"
                    :value="storeCode" @input="(val) => storeCode = val"></codeEditorMini>
                </el-tab-pane>
            </el-tabs>
        </el-drawer>
    </div>
</template>

<script>
import FileSaver from 'file-saver'
import codeEditor from './../../components/codeEditor.vue'
import codeEditorMini from './../../components/codeEditorMini.vue'
import { makeNewCode, titleCase } from './SqliteHelp.js'
import { makeControllersCode } from './Controllers.js'
import { makeViewsCode } from './Views.js'
import { makeBindingsCode } from './Bindings.js'
import { makeEditControllersCode } from './EditControllers.js'
import { makeEditViewsCode } from './EditViews.js'
import { makeEditBindingsCode } from './EditBindings.js'
import { makeElementCode } from './Element.js'
import { makeListViewCode } from './ListView.js'
import { makePagesCode } from './Pages.js'
import { makeRoutesCode } from './Routes.js'
import { makeStoreCode } from './Store.js'
export default {
    name: "Home",
    components: {
        codeEditor,
        codeEditorMini
    },
    data() {
        return {
            drawer: false,
            activeName: 'views',
            showEditor: true,
            showControllersEditor: true,
            showViewsEditor: true,
            showBindingsEditor: true,
            showEditControllersEditor: true,
            showEditViewsEditor: true,
            showEditBindingsEditor: true,
            showElementEditor: true,
            showListViewEditor: true,
            showPagesEditor: true,
            showRoutesEditor: true,
            showStoreEditor: true,
            language: 'java',
            code: '',
            controllersCode: '',
            viewsCode: '',
            bindingsCode: '',
            editControllersCode: '',
            editViewsCode: '',
            editBindingsCode: '',
            elementCode: '',
            listViewCode: '',
            pagesCode: '',
            routesCode: '',
            storeCode: '',
            searchOption: [
                {
                    value: 'none',
                    label: '不搜索'
                },
                {
                    value: 'like',
                    label: '模糊搜索'
                },
                {
                    value: 'equal',
                    label: '精确搜索'
                }
            ],
            typeOption: [
                {
                    value: 'INTEGER PRIMARY KEY AUTOINCREMENT',
                    label: '自增主键ID'
                },
                {
                    value: 'INTEGER',
                    label: '整型'
                },
                {
                    value: 'FLOAT',
                    label: '浮点型'
                },
                {
                    value: 'TEXT',
                    label: '字符串'
                },
                {
                    value: 'REAL',
                    label: '数值'
                },
                {
                    value: 'BLOB',
                    label: 'Uint8List'
                }
            ],
            tableName: '',
            tableData: [
                {
                    name: 'id',
                    typ: 'INTEGER PRIMARY KEY AUTOINCREMENT',
                    search: 'none'
                }
            ],
        }
    },
    computed: {
        leftCol: {
            get() {
                return this.$store.state.pageData.leftCol
            },
            set(value) {
                this.$store.commit('pageData/setLeftCol', value)
            }
        },
        dbName: {
            get() {
                return this.$store.state.tableData.dbName
            },
            set(value) {
                this.$store.commit('tableData/setDbName', value)
            }
        },
        tableNames: {
            get() {
                return this.$store.state.tableData.tableNames
            },
            set(value) {
                this.$store.commit('tableData/setTableNames', value)
            }
        },
        tableDatas: {
            get() {
                return this.$store.state.tableData.tableDatas
            },
            set(value) {
                this.$store.commit('tableData/setTableDatas', value)
            }
        },
        lockData: {
            get() {
                return this.$store.state.tableData.lockData
            },
            set(value) {
                this.$store.commit('tableData/setLockData', value)
            }
        },
    },
    watch: {
        dbName: {
            immediate: true,
            handler: function (newval) {
                if (!this.lockData) this.setCode(makeNewCode(this.dbName, this.tableNames, this.tableDatas))
            },
        },
        tableDatas: {
            immediate: true,
            deep: true,
            handler: function (newval) {
                // console.log("tableDatas", this.tableDatas)
                if (!this.lockData) this.setCode(makeNewCode(this.dbName, this.tableNames, this.tableDatas))
            },
        },
        tableNames: {
            immediate: true,
            deep: true,
            handler: function (newval) {
                // console.log("tableNames", this.tableNames)
                if (!this.lockData) this.setCode(makeNewCode(this.dbName, this.tableNames, this.tableDatas))
            },
        },
        lockData: {
            immediate: true,
            handler: function (newval) {
                if (!this.lockData) this.setCode(makeNewCode(this.dbName, this.tableNames, this.tableDatas))
            },
        },
    },
    created() {
        if (this.tableNames.length > 0 && (this.tableName == '' || this.tableNames.indexOf(this.tableName) == -1)) { this.tableName = this.tableNames[0] }
    },
    methods: {
        titleCase,
        leftMove(){
            if (this.leftCol > 0) {
                this.leftCol = this.leftCol - 1
            }
        },
        rightMove(){
            if (this.leftCol < 24) {
                this.leftCol = this.leftCol + 1
            }
        },
        download(){
            let allData = {
                dbName: this.dbName,
                tableNames: this.tableNames,
                tableDatas: this.tableDatas,
                lockData: this.lockData
                
            }
            const blob = new Blob([JSON.stringify(allData, null, 2)], {type: 'application/json'})
            FileSaver.saveAs(blob, this.dbName + '.json')
        },
        changeFile(file, fileList) {
            console.log(file)
            const isJSON = file.raw.type === 'application/json'; 
            if (!isJSON) {
                return this.$message.error('只允许导入JSON文件，请导出默认数据后参考数据格式!');
            }
            let that = this
            var reader = new FileReader();
            reader.readAsText(file.raw)
            reader.onload = ((e) => {
                let jsonData = {}
                if (e.target.result) {
                    jsonData = JSON.parse(e.target.result)
                    console.log(jsonData)
                    if (jsonData && jsonData.hasOwnProperty('dbName') && jsonData.hasOwnProperty('tableNames') && jsonData.hasOwnProperty('tableDatas') && jsonData.hasOwnProperty('lockData')) {
                        this.dbName = jsonData.dbName
                        this.tableNames = jsonData.tableNames
                        this.tableDatas = jsonData.tableDatas
                        this.lockData = jsonData.lockData
                        location.reload()
                        return this.$message.success('导入成功!');
                    } else {
                        console.log("数据缺失")
                        return this.$message.error('JSON数据有误，请导出默认数据后参考数据格式!');
                    }
                } else {
                    return this.$message.error('JSON数据有误，请导出默认数据后参考数据格式!');
                }
            })
        },
        imgHover() {
            let element = document.getElementById('codeIcon')
            if (element) {
                element.setAttribute('src', '/img/icons/code0.png');
            }
        },
        imgUnHover() {
            let element = document.getElementById('codeIcon')
            if (element) {
                element.setAttribute('src', '/img/icons/code1.png');
            }
        },
        makeCode(){
            this.activeName = 'views'
            this.drawer = true
            this.setViewsCode()
        },
        setControllersCode() {
            this.showControllersEditor = false
            this.$nextTick(() => {
                this.controllersCode = makeControllersCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showControllersEditor = true
            })
        },
        setViewsCode() {
            this.showViewsEditor = false
            this.$nextTick(() => {
                this.viewsCode = makeViewsCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showViewsEditor = true
            })
        },
        setBindingsCode() {
            this.showBindingsEditor = false
            this.$nextTick(() => {
                this.bindingsCode = makeBindingsCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showBindingsEditor = true
            })
        },
        setEditControllersCode() {
            this.showEditControllersEditor = false
            this.$nextTick(() => {
                this.editControllersCode = makeEditControllersCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showEditControllersEditor = true
            })
        },
        setEditViewsCode() {
            this.showEditViewsEditor = false
            this.$nextTick(() => {
                this.editViewsCode = makeEditViewsCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showEditViewsEditor = true
            })
        },
        setEditBindingsCode() {
            this.showEditBindingsEditor = false
            this.$nextTick(() => {
                this.editBindingsCode = makeEditBindingsCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showEditBindingsEditor = true
            })
        },
        setElementCode() {
            this.showElementEditor = false
            this.$nextTick(() => {
                this.elementCode = makeElementCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showElementEditor = true
            })
        },
        setListViewCode() {
            this.showListViewEditor = false
            this.$nextTick(() => {
                this.listViewCode = makeListViewCode(this.dbName, this.tableName, this.tableNames, this.tableDatas)
                this.showListViewEditor = true
            })
        },
        setPagesCode() {
            this.showPagesEditor = false
            this.$nextTick(() => {
                this.pagesCode = makePagesCode(this.dbName, this.tableNames, this.tableDatas)
                this.showPagesEditor = true
            })
        },
        setRoutesCode() {
            this.showRoutesEditor = false
            this.$nextTick(() => {
                this.routesCode = makeRoutesCode(this.dbName, this.tableNames, this.tableDatas)
                this.showRoutesEditor = true
            })
        },
        setStoreCode() {
            this.showStoreEditor = false
            this.$nextTick(() => {
                this.storeCode = makeStoreCode(this.dbName, this.tableNames, this.tableDatas)
                this.showStoreEditor = true
            })
        },
        handleClick(tab, event) {
            if (this.activeName == 'controllers') { return this.setControllersCode() }
            if (this.activeName == 'views') { return this.setViewsCode() }
            if (this.activeName == 'bindings') { return this.setBindingsCode() }
            if (this.activeName == 'editControllers') { return this.setEditControllersCode() }
            if (this.activeName == 'editViews') { return this.setEditViewsCode() }
            if (this.activeName == 'editBindings') { return this.setEditBindingsCode() }
            if (this.activeName == 'element') { return this.setElementCode()}
            if (this.activeName == 'listView') { return this.setListViewCode()}
            if (this.activeName == 'pages') { return this.setPagesCode() }
            if (this.activeName == 'routes') { return this.setRoutesCode() }
            if (this.activeName == 'store') { return this.setStoreCode() }
        },
        showActiveName(activeName) {
            if (activeName == 'controllers') { return `lib/app/modules/${this.tableName}/controllers/${this.tableName}_controller.dart` }
            if (activeName == 'views') { return `lib/app/modules/${this.tableName}/views/${this.tableName}_view.dart` }
            if (activeName == 'bindings') { return `lib/app/modules/${this.tableName}/bindings/${this.tableName}_binding.dart` }
            if (this.activeName == 'editControllers') { return `lib/app/modules/${this.tableName}/controllers/edit_${this.tableName}_controller.dart` }
            if (this.activeName == 'editViews') { return `lib/app/modules/${this.tableName}/views/edit_${this.tableName}_view.dart` }
            if (this.activeName == 'editBindings') { return `lib/app/modules/${this.tableName}/bindings/edit_${this.tableName}_binding.dart` }
            if (this.activeName == 'element') { return `lib/util/${this.tableName}_element.dart`}
            if (this.activeName == 'listView') { return `lib/util/${this.tableName}_list_view.dart`}
            if (activeName == 'pages') { return "lib/app/routes/app_pages.dart" }
            if (activeName == 'routes') { return "lib/app/routes/app_routes.dart" }
            if (activeName == 'store') { return "lib/store/page_store.dart"}
        },
        cleanData() {
            if (!this.lockData) {
                this.$confirm('此操作将重置所有数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('tableData/cleanForm')
                    if (this.tableNames.length > 0) { this.tableName = this.tableNames[0] }
                    location.reload()
                    this.$message({
                        type: 'success',
                        message: '重置成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            } else {
                return this.$message.error('内容处于保护状态，请先解锁一下内容!');
            }
        },
        updateData() {
            this.tableNames = JSON.parse(JSON.stringify(this.tableNames))
            this.tableDatas = JSON.parse(JSON.stringify(this.tableDatas))
        },
        addData() {
            this.tableDatas[this.tableName].push({ name: "", epithet:"", typ: "TEXT", searchTyp: "none", search: false, only: false, new: false })
            this.updateData()
        },
        delData(row, index) {
            this.tableDatas[this.tableName].splice(index, 1)
            this.updateData()
        },
        languageChange(label) {
            this.language = label
        },
        setCode(newCode) {
            this.showEditor = false
            this.$nextTick(() => {
                this.code = newCode
                this.showEditor = true
            })
        },
        tableNameChange(value) {
            let newTableNames = JSON.parse(JSON.stringify(this.tableNames))
            let newTableDatas = JSON.parse(JSON.stringify(this.tableDatas))
            if (newTableNames.indexOf(value) == -1) {
                newTableNames.push(value)
                newTableDatas[value] = [
                    {
                        name: "id",
                        epithet:"ID",
                        typ: "INTEGER PRIMARY KEY AUTOINCREMENT",
                        searchTyp: "equal",
                        search: false,
                        only: true,
                        new: false
                    },
                    {
                        name: "name",
                        epithet:"名称",
                        typ: "TEXT",
                        searchTyp: "none",
                        search: false,
                        only: false,
                        new: false
                    },
                ]
                this.tableNames = newTableNames
                this.tableDatas = newTableDatas
            }
        },
        delItem(value) {
            this.$confirm('此操作将同步删除该表单下字段信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let newTableNames = JSON.parse(JSON.stringify(this.tableNames))
                let newTableDatas = JSON.parse(JSON.stringify(this.tableDatas))

                let delIndex = newTableNames.indexOf(value)
                newTableNames.splice(delIndex, 1)
                delete newTableDatas[value]
                if (delIndex != 0) {
                    delIndex = delIndex - 1
                }
                if (newTableNames.length > 0) {
                    this.tableName = newTableNames[delIndex]
                } else {
                    this.tableName = ''
                }
                this.tableNames = newTableNames
                this.tableDatas = newTableDatas
                this.$message({ type: 'success', message: '删除成功!' });
            }).catch(() => {
                this.$message({ type: 'info', message: '已取消删除' });
            });
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-container {
    margin: 0 !important;
    padding: 0 !important;
}
::v-deep .el-aside {
    margin: 0 !important;
    padding: 0 !important;
    border-right:1px solid #000000;
}
::v-deep .el-main {
    margin: 0 !important;
    padding: 0 !important;
}
::v-deep .el-drawer {
    border-radius: 50px 50px 0 0 !important; 
}
::v-deep .el-drawer__header {
    padding: 20px 40px 0 !important; 
    font-size: 20px;
    font-weight: 600;
}
.drawer-header {
    color:#393939;
    padding: 20px 40px 10px; 
    font-size: 20px;
    font-weight: 600;
}
.tab-box {
    padding: 0 30px;
    height: calc( 100% - 120px);
    ::v-deep .el-tabs__content {
        height: 100%;
        .el-tab-pane {
            height: 100%;
        }
    }
}
.menu-logo {
    color:#FFFFFF;
    width:100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.menu-icon {
    cursor: pointer;
    color:#FFFFFF;
    margin: 10px 0;
    width:100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
    background: linear-gradient(#FFFFFF 0 0) var(--p, 0) / var(--p, 0) no-repeat;
    transition: .4s, background-position 0s;
}
.menu-icon:hover {
    --p: 100%;
    color: #000000;
}
</style>
